export function scrollToId(hash) {
  const el = document.querySelector(hash);
  if (!el) {
    // Off-home route: navigate to the home page anchor.
    window.location.assign("/" + hash);
    return;
  }
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
